import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UpdatepromptComponent } from './updateprompt.component';



@NgModule({
  declarations: [UpdatepromptComponent],
  imports: [
    CommonModule
  ],
  exports: [UpdatepromptComponent]
})
export class UpdatepromptModule { }
